export default __webpack_public_path__ + "static/media/IBimagehiplock1.10516b8c.png";